export enum MountType {
    Wall = 'wall',
    Flybars = 'fly',
    GroundStack = 'ground',
    Custom = 'custom',
}

export interface IMount {
    type: MountType;
    name: string;
    cost: number;
    priceUnit: 'per-unit' | 'per-square-meter'
}

export const mounts: Map<MountType, IMount> = new Map(
    [
        [MountType.Wall, { type: MountType.Wall, name: 'Wall Mount', cost: 65, priceUnit: 'per-square-meter' }],
        [MountType.Flybars, { type: MountType.Flybars, name: 'Flybars', cost: 50, priceUnit: 'per-unit' }],
        [MountType.GroundStack, { type: MountType.GroundStack, name: 'Ground Stack Support', cost: 130, priceUnit: 'per-square-meter' }],
    ]
);
